import config from '@packages/common/config.js';
import dayjs from 'dayjs';

var filter = {
    // 阿里相册前缀
    aliAlbumFormat(src, size, isNeedHost = true) {
        if (!src) {
            return config.defaultImg;
        }
        if (size) {
            const match = src.match(/\.\w+$/);
            const ext = match && match.length ? match[0] : '';
            src = src.replace('.search', ``);
            src = src.replace(/(\.\d+x\d+)?\.\w+$/, `.${size}${ext}`);
        }
        return (isNeedHost ? config.aliAlbumHost : '') + src;
    },
    // 图片前缀
    imageFormat(src) {
        if (!src) {
            return '';
        }
        return config.imgUrl + src;
    },
    imgFormat(url, size, isNeedHost = true) {
        const hasHost = url.startsWith('http');
        const isAlicdn = url.includes('img/ibank');
        if (size && isAlicdn) {
            url = url.replace(/(.\w+$)/g, `.${size}x${size}$1`);
        }
        if (hasHost) {
            return url;
        } else {
            return (isNeedHost ? config.alicdn : '') + url;
        }
    },
    // 图片剪裁
    imageThumb(src, w, h) {
        if (!src) {
            return '';
        }
        const width = w || 272;
        const heigh = h || 438;
        return src + `?x-oss-process=image/resize,w_${width},image/crop,x_0,y_0,w_${width},h_${heigh}`;
    },
    // 提取时间戳 example:/Date(1558591720000)/
    timeStampFormat(str) {
        if (!str) {
            return '';
        }
        // let reg = /(?<=\/Date\().+(?=\)\/)/;
        const reg = /(\/Date\((\d+)\)\/)/;
        const match = str.match(reg);
        if (match && match.length >= 3) {
            return parseInt(match[2]);
        }
        return '';
    },
    // 格式化时间
    dateFormat(timestamp, format = 'YYYY-MM-DD HH:mm') {
        if (!timestamp) {
            return '';
        }
        const date = dayjs(timestamp);
        if (date.isValid()) {
            return date.format(format);
        }
        return '';
    },
    albumFormat(src, isbg) {
        if (!src) {
            return;
        }
        const baseUrl = 'https://cbu01.alicdn.com/';

        src = baseUrl + src;
        if (isbg) {
            return 'background-image:url(' + src + ')';
        }
        return src;
    },
};

const install = function (Vue) {
    for (var filteritem in filter) {
        Vue.filter(filteritem, filter[filteritem]);
    }
};

export default {
    install,
    // eslint-disable-next-line eol-last
};
